import styled from 'styled-components'

export const SealsArea = styled.section`
    border-bottom: 1px solid #ecedf2;
    padding: 36px 40px;
    position: relative;
    z-index: 20;
    height: ${props => (props.moreHeight ? '250px' : '170px')};
    
    @media screen and (max-width: 1200px) {
        z-index: initial;
    }
`

export const Text = styled.h4`
    font-size: 12px;
    line-height: 150%;
    color: #696977;
    font-weight: normal;
`

export const Seals = styled.div`
    margin-top: 24px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: absolute;
    width: 90%;
`

export const SealArea = styled.div`
    max-height: ${props => (props.hover ? '300px' : '50px')};
    box-shadow: ${props => props.hover && '0px 16px 16px rgba(46, 45, 55, 0.4)'};
    overflow: hidden;
    border-radius: 8px;
    transition: max-height 0.7s ease-in, opacity 0.7s ease-in,
     box-shadow 0.7s ease-in;
    padding: 0 20px 20px 20px;
    max-width: 33%;
    background-color: #fff;
`

export const SealHeader = styled.div`
    display: flex;
    flex: 1;
    justify-content: space-around;
    align-items: center;
`

export const StampText = styled.strong`
    font-weight: 500;
    font-size: 16px;
    color: #000;
`

export const Tooltip = styled.div`
    max-height: ${props => (props.hover ? '300px' : '0px')};
    opacity: ${props => (props.hover ? '1' : '0')};
    transition: max-height 0.7s ease-in, opacity 0.7s ease-in;
`

export const StrongText = styled.strong`
    font-weight: 700;
    color: #2d2d37;
    font-size: 14px;
`

export const Description = styled.p`
    color: #2d2d37;
    line-height: 150%;
    font-weight: normal;
    display: inline;
    font-size: 14px;
`

export const Link = styled.a`
    font-weight: 700;
    color: #f3123c;
    display: block;
    font-size: 14px;
    margin-top: 10px;
`

export const AboutTheAd = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`
